import React, { Fragment } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../constant/TYPE";
import KeypadShowButton from "./KeypadShowButton";
import NumberKeypad from "./numberKeypad/NumberKeypad";
import CalculationKeypad from "./calculationKeypad/CalculationKeypad";
import ComplexCalculationKeypad from "./complexCalculationKeypad/ComplexCalculationKeypad";
import Notepad from "./notepad/Notepad";
import SubmitButtons from "./numberKeypad/submitButtons/SubmitButtons";
import NotepadChangeButton from "./numberKeypad/submitButtons/NotepadChangeButton";
import KeypadChangeButton from "./notepad/submitButtons/KeypadChangeButton";
import AnswerEditor from "./AnswerEditor";
import HackleNoteBtn from "../../../../../common/HackleNoteBtn";
import HackleConceptBtn from "../../../../../common/HackleConceptBtn";
import MultipleChoiceQuestionKeypad from "./multipleChoiceQuestionKeypad/MultipleChoiceQuestionKeypad";
import MultipleChoiceQuestion from "./multipleChoiceQuestionKeypad/MultipleChoiceQuestion";

const Input = ( props ) => {

  const deviceInfo = useSelector( state => state.deviceInfo );
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const useInfo = useSelector( state => state.user.info );

  const {
    KeypadShower,
    KeyPresser,
    KeyClicker,
    NoteTaker,
    AnswerEditorController,
    Submitter,
    children,
    ...PROPS
  } = props;

  const KEYPAD_SUBMIT_BUTTONS = <Submitter><SubmitButtons><NotepadChangeButton /></SubmitButtons></Submitter>;
  const NOTEPAD_SUBMIT_BUTTONS = <Submitter><SubmitButtons><KeypadChangeButton /></SubmitButtons></Submitter>;

  const KEYPAD = {
    [ TYPE.KEYPAD.NUMBER ] : <KeyClicker { ...PROPS }><NumberKeypad>{ KEYPAD_SUBMIT_BUTTONS }</NumberKeypad></KeyClicker>,
    [ TYPE.KEYPAD.CALCULATION ] : <KeyClicker { ...PROPS }><CalculationKeypad>{ KEYPAD_SUBMIT_BUTTONS }</CalculationKeypad></KeyClicker>,
    [ TYPE.KEYPAD.COMPLEX_CALCULATION ] : <KeyClicker { ...PROPS }><ComplexCalculationKeypad>{ KEYPAD_SUBMIT_BUTTONS }</ComplexCalculationKeypad></KeyClicker>,
    [ TYPE.KEYPAD.NOTE ] : <NoteTaker { ...PROPS }><Notepad>{ NOTEPAD_SUBMIT_BUTTONS }</Notepad></NoteTaker>,
    [TYPE.KEYPAD.MULTIPLE]: <MultipleChoiceQuestion {...PROPS}><MultipleChoiceQuestionKeypad /></MultipleChoiceQuestion>
  };

  return (
    <div className={clsx(
      'learningTail',
      TYPE.DEVICE.PAD === deviceInfo.type && answeringQuestions.isShowKeypad && 'on',
      (answeringQuestions.data.objctYn === 'Y') && 'multiple'
    )
    }>
      <div className={ clsx( 'onlyButtonBox', ! answeringQuestions.isShowKeypad && 'active' ) }>
        { ! answeringQuestions.isShowKeypad && <KeypadShower><KeypadShowButton className="btn-blue" { ...PROPS } /></KeypadShower> }
      </div>
      <KeyPresser { ...PROPS }>
        { 
          answeringQuestions.data.objctYn === 'Y' 
            ? answeringQuestions.isShowKeypad && KEYPAD[TYPE.KEYPAD.MULTIPLE]
            : answeringQuestions.isShowKeypad && KEYPAD[answeringQuestions.keypadType]          
        }
        </KeyPresser>
      { answeringQuestions.isShowKeypad && <AnswerEditorController><AnswerEditor /></AnswerEditorController> }
      <HackleConceptBtn { ...PROPS }/> 
      { useInfo.channelCode === TYPE.ENTRY_TYPE.GLOBAL01 && answeringQuestions.isShowKeypad && <HackleConceptBtn { ...PROPS }/> }
      { useInfo.channelCode === TYPE.ENTRY_TYPE.GLOBAL01 && answeringQuestions.isShowKeypad && <HackleNoteBtn { ...PROPS } location='inputer'/> }
    </div>
  );

};

Input.defaultProps = {
  KeypadShower : Fragment,
  KeyPresser : Fragment,
  KeyClicker : Fragment,
  NoteTaker : Fragment,
  AnswerEditorController : Fragment,
  Submitter : Fragment
};

export default Input;
